import * as superagent from 'superagent'

export type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export function methodRequest(method: Method, url: string) {
    switch (method) {
        case 'GET':
            return superagent.get(url)
        case 'POST':
            return superagent.post(url)
        case 'PUT':
            return superagent.put(url)
        case 'PATCH':
            return superagent.patch(url)
        case 'DELETE':
            return superagent.del(url)
    }
}
